import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import type { ApiClientOptions } from '../api/client';
import { AuthGate } from '../auth/AuthGate';
import { ToastProvider } from '../components/Toaster';
import { createQueryClient } from './queryClient';
import { routes } from './routes';

function Router() {
  // Created after sign-in so the router starts at the location restored from the OIDC callback.
  const [router] = useState(() => createBrowserRouter(routes));
  return <RouterProvider router={router} />;
}

export function App({ apiOptions }: { apiOptions: ApiClientOptions }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthGate options={apiOptions}>
          <Router />
        </AuthGate>
      </ToastProvider>
    </QueryClientProvider>
  );
}
